import { defineMessages } from 'react-intl-next';

export default defineMessages({
    attachmentField: {
        defaultMessage: 'Drag and drop files, paste screenshots, or browse',
        description: 'Label for attachments area',
        id: 'cv.request.create.form.field.attachment',
    },
    attachmentFieldButton: {
        defaultMessage: 'Browse',
        description: 'Label for button to open browse modal in attachments area',
        id: 'cv.request.create.form.field.attachment.button',
    },
    attachmentFieldButtonAriaLabel: {
        defaultMessage: 'Browse your device for attachments',
        description: 'Aria Label for button to open browse modal in attachments area',
        id: 'cv.request.create.form.field.attachment.button.aria.label',
    },
    attachmentPreviewLabel: {
        defaultMessage: 'Attachment',
        description: 'Label for the attachment preview image',
        id: 'cv.request.create.form.field.attachment.preview.label',
    },
    attachmentRemoveLabel: {
        defaultMessage: 'Remove attachment',
        description: 'Label for button to remove an attachment',
        id: 'cv.request.create.form.field.attachment.remove.label',
    },
    attachmentUploadFailed: {
        defaultMessage: 'Upload failed',
        description: 'Message to show when an individual attachment upload fails',
        id: 'cv.request.create.form.field.attachment.upload.failed',
    },
});
